import React, { useState } from "react";
import { Link } from "react-router-dom";
import Spinner from "../components/Spinner";
import { SERVER_BASE_URL } from "../config";

function ResetPasswordPage() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");
        setLoading(true);

        try {
            const response = await fetch(`${SERVER_BASE_URL}/api/users/forgot-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }),
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.detail || "Failed to send password reset email.");
            }

            const data = await response.json();
            setMessage(data.detail || "Password reset link sent to your email.");
        } catch (err) {
            console.error(err.message);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 w-full max-w-md mx-4">
                <div className="text-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">Reset Your Password</h2>
                    <p className="text-gray-600 mt-1">We&apos;ll send you a link to reset your password</p>
                
                </div>
                
                {message && (
                    <div className="p-4 bg-green-50 border border-green-200 rounded-md mb-6">
                        <p className="text-green-700 text-center">{message}</p>
                        <div className="mt-4 text-center">
                            <Link 
                                to="/login" 
                                className="text-indigo-600 hover:text-indigo-800 font-medium"
                            >
                                Return to login
                            </Link>
                        </div>
                    </div>
                )}
                
                {error && (
                    <div className="p-3 bg-red-50 border border-red-200 rounded-md mb-4">
                        <p className="text-sm text-red-600 text-center">{error}</p>
                    </div>
                )}
                
                {!message && (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Email Address
                            </label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                                placeholder="Enter your email"
                                required
                            />
                            <p className="mt-2 text-sm text-gray-500">
                                Enter the email address associated with your account
                            </p>
                        </div>
                        
                        <button
                            type="submit"
                            className={`w-full bg-indigo-600 text-white py-2 px-4 rounded-md font-medium flex items-center justify-center ${
                                loading ? "opacity-70 cursor-not-allowed" : "hover:bg-indigo-700"
                            } transition duration-200 mt-2`}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Spinner className="w-5 h-5 mr-2" />
                                    <span>Sending...</span>
                                </>
                            ) : (
                                "Send Reset Link"
                            )}
                        </button>
                        
                        <div className="mt-4 text-center">
                            <p className="text-sm text-gray-600">
                                Remember your password?{" "}
                                <Link to="/login" className="text-indigo-600 hover:text-indigo-800 font-medium">
                                    Sign in
                                </Link>
                            </p>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}

export default ResetPasswordPage;